(() => {
  const MOBILE = '(max-width: 749px)';
  const mediaQuery = window.matchMedia(MOBILE);
  const ROOT_SELECTOR = 'product-info[id^="MainProduct"] media-gallery';
  const galleryUpdates = new WeakMap();

  const setup = (gallery) => {
    if (!gallery || !mediaQuery.matches) return;

    const stage = gallery.querySelector('.main-product-gallery');
    const viewer = stage?.querySelector('.product__media-list');
    if (!stage || !viewer) return;

    if (stage.dataset.szGalleryUiReady === 'true') return;
    stage.dataset.szGalleryUiReady = 'true';

    const getSlides = () =>
      Array.from(viewer.querySelectorAll('.product__media-item')).filter((item) => !item.hidden);

    const counter = document.createElement('span');
    counter.className = 'sz-gallery-count';
    counter.setAttribute('aria-hidden', 'true');
    stage.append(counter);

    let raf = 0;
    let lastIndex = -1;
    let lastTotal = -1;
    let lastMediaId = '';

    const updateActiveThumbnail = (slides, index) => {
      const activeItem = slides[index];
      const mediaId = activeItem?.dataset?.mediaId;
      if (!mediaId) return;

      gallery.querySelectorAll('.thumbnail').forEach((button) => button.removeAttribute('aria-current'));
      const thumb = gallery.querySelector('[data-target="' + mediaId + '"] .thumbnail');
      if (thumb) thumb.setAttribute('aria-current', 'true');
    };

    const update = () => {
      raf = 0;

      const slides = getSlides();
      const total = slides.length;

      if (!total) {
        lastIndex = -1;
        lastTotal = 0;
        lastMediaId = '';
        counter.hidden = true;
        stage.classList.add('sz-gallery-single');
        return;
      }

      const width = Math.max(1, viewer.clientWidth);
      const index = Math.max(0, Math.min(total - 1, Math.round(viewer.scrollLeft / width)));
      const mediaId = slides[index]?.dataset?.mediaId || '';

      if (index === lastIndex && total === lastTotal && mediaId === lastMediaId) return;
      lastIndex = index;
      lastTotal = total;
      lastMediaId = mediaId;

      counter.hidden = total <= 1;
      stage.classList.toggle('sz-gallery-single', total <= 1);
      counter.textContent = (index + 1) + ' / ' + total;
      updateActiveThumbnail(slides, index);

      const progress = ((index + 1) / total) * 100;
      stage.style.setProperty('--sz-gallery-progress', progress.toFixed(2) + '%');
    };

    const queueUpdate = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    viewer.addEventListener('scroll', queueUpdate, { passive: true });
    galleryUpdates.set(gallery, queueUpdate);

    new MutationObserver(queueUpdate).observe(viewer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'class']
    });

    update();
    window.setTimeout(update, 160);
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(setup);
    if (scope.matches?.(ROOT_SELECTOR)) setup(scope);
  };

  const recheck = () => {
    if (mediaQuery.matches) init();
  };

  const updateVisibleGalleries = () => {
    if (!mediaQuery.matches) return;
    document.querySelectorAll(ROOT_SELECTOR).forEach((gallery) => galleryUpdates.get(gallery)?.());
  };

  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => init(event.target), 0);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('product-info')) return;
    window.setTimeout(recheck, 100);
  });

  if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', recheck);
  else mediaQuery.addListener(recheck);

  window.addEventListener('resize', updateVisibleGalleries, { passive: true });
  init();
})();
